import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { TableProps } from './Table'

interface TableBlokProps {
  blok: {
    alignment: string
    title: TableProps['title']
    table: any
  } & SbBlokData
}

const Table: FC<TableBlokProps> = ({ blok }) => {
  return (
    <div
      {...storyblokEditable(blok)}
      style={{
        width: '100%',
        display: 'flex',
        justifyContent:
          blok.alignment === 'left'
            ? 'flex-start'
            : blok.alignment === 'right'
              ? 'flex-end'
              : 'center',
      }}
    >
      <table>
        <thead>
          <tr>
            {blok.table.thead.map((th: any, index: any) => (
              <th key={index}>{th.value}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {blok.table.tbody.map((tr: any, index: any) => (
            <tr key={index}>
              {tr.body.map((td: any, index: any) => (
                <td key={index}>{td.value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Table
